import { OnboardingCardBG, MoneyBag } from "../../assets/svgs";
import "./styles.scss";

const OnboardingCard = ({
  cardBackgroundImage,
  cardDescription,
  cardHeading,
}) => {

  return (
    <div className="header-onboarding-card">
      <img src={OnboardingCardBG} className="card-image-bg" alt="" />
      <div className="card-heading-container">
        <img src={MoneyBag} alt="" />
        <p className="card-heading">
          {cardHeading}
        </p>
      </div>
      <p className="card-description">
        {cardDescription}
      </p>
    </div>
  );
};

export default OnboardingCard;
